export const SET_SEARCH_TERM = "SET_SEARCH_TERM";
export const SET_SEARCH_SORT_ORDER = "SET_SEARCH_SORT_ORDER";
export const SET_SEARCH_SORT_FIELD = "SET_SEARCH_SORT_FIELD";
export const SET_SEARCH_PAGE = "SET_SEARCH_PAGE";
export const SET_SEARCH_FILTERS = "SET_SEARCH_FILTERS";
export const SET_SEARCH_SORT = "SET_SEARCH_SORT";
export const SET_SEARCH_RESULTS = "SET_SEARCH_RESULTS";
export const RESET_SEARCH = "RESET_SEARCH";
export const RESET_SORT = "RESET_SORT";
